var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFree = function SvgFree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 40.8 40.8"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 20.4a20.4 20.4 0 1 1 20.4 20.4A20.4 20.4 0 0 1 0 20.4"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8.79 16.43v2.63h2.68v1.31H8.79v4.46h-1.6V15.1h5.09l-.2 1.34zm8.5 6.9q-.5-.9-.87-1.45a8 8 0 0 0-.76-1 1.2 1.2 0 0 0-.26-.21.85.85 0 0 0-.36-.08v4.21h-1.59v-9.7h2.93a3.9 3.9 0 0 1 1.4.23 2.7 2.7 0 0 1 1 .6 2.4 2.4 0 0 1 .57.89 3 3 0 0 1 .19 1.07 3.2 3.2 0 0 1-.16 1 2.5 2.5 0 0 1-.47.85 2.4 2.4 0 0 1-.76.59 2.2 2.2 0 0 1-1 .23 1.2 1.2 0 0 1 .31.27c.12.13.24.29.38.46s.27.37.4.58l.4.63L20 24.83h-1.88zm.12-6.55a2.35 2.35 0 0 0-1.51-.37H15v3.08h.82a4.2 4.2 0 0 0 1-.09 1.23 1.23 0 0 0 .58-.32 1.5 1.5 0 0 0 .31-.5 1.9 1.9 0 0 0 .12-.68 1.39 1.39 0 0 0-.43-1.12zm4.28-1.68H27l-.21 1.34h-3.5v2.64h3v1.34h-2.97v3h3.85v1.38h-5.48zm7.2 0h5.34L34 16.43h-3.51v2.64h3v1.34h-2.97v3h3.85v1.38h-5.48z"
  })))));
};
export default SvgFree;